














































import { ref, onUnmounted } from '@vue/composition-api';
import { getDoctorInfoStorage } from '@/utils/utils';
export default {
  setup(props, { root }: any) {
    const username = ref('');
    const patientName = ref('');
    const modelSelect = ref('数据平台');
    const showFollowUpTab = ref(false);
    const showPatientRecruitTab = ref(false);
    const recruitmentSelect = ref('');
    const projectName = ref('数据分析平台');
    const isCenterAdmin = ref(false);
    const options = ref([
      // 宁夏项目新加模块 begin
      {
        value: '项目进度查询',
        type: 'platformData',
      },
      {
        value: '项目数据统计',
        type: 'platformData',
      },
      {
        value: '个人信息查询',
        type: 'platformData',
      },
      {
        value: '系统管理',
        type: 'platformData',
      },
      // 宁夏项目新加模块 end
    ]);
    const fullPath = ref({
      项目进度查询: '/dataDefault/progress',
      项目数据统计: '/dataDefault/data',
      个人信息查询: '/dataDefault/personalInformationList',
      系统管理: '/dataDefault/projectList',
    });
    const refPlatformData = ref(null);

    const logout = async () => {
      const { err } = await root.$http.post('/hospital/logout', {});
      if (err) {
        throw new Error('弹窗拦截');
      }
      root.$router.replace({
        path: '/dataAnalysisLogin',
      });
    };
    const clearAllSelect = () => {
      modelSelect.value = '';
      recruitmentSelect.value = '';
    };

    const manageChange = (val: string) => {
      root.$router.push({
        path: fullPath.value[val],
      });
      clearAllSelect();
    };
    const hideTimer = {
      dataPlatform: -1,
    };
    const mouseenter = (e: Event, type = 'dataPlatform') => {
      const refPlatformDataValue = refPlatformData.value as any;
      if (refPlatformDataValue || refPlatformDataValue.$refs.popper.$el.contains(e.target)) {
        clearTimeout(hideTimer[type]);
        refPlatformDataValue.visible = true;
      }
      const show = () => {
        clearTimeout(hideTimer[type]);
        refPlatformDataValue.visible = true;
      };
      const hide = () => {
        clearTimeout(hideTimer[type]);
        hideTimer[type] = setTimeout(() => {
          refPlatformDataValue.visible = false;
        }, 150);
      };
      refPlatformDataValue.$refs.popper.$el.removeEventListener('mouseover', show, false);
      refPlatformDataValue.$refs.popper.$el.removeEventListener('mouseleave', hide, false);
      refPlatformDataValue.$refs.popper.$el.addEventListener('mouseover', show, false);
      refPlatformDataValue.$refs.popper.$el.addEventListener('mouseleave', hide, false);
    };

    const mouseleave = (e, type = 'dataPlatform') => {
      if (refPlatformData.value) {
        clearTimeout(hideTimer[type]);
        hideTimer[type] = setTimeout(() => {
          (refPlatformData.value as any).visible = false;
        }, 150);
      }
    };
    onUnmounted(() => {
      localStorage.removeItem('CenterAdmin');
      localStorage.removeItem('CenterAdminMessage');
    });
    document.addEventListener('visibilitychange', () => {
      const localInfo = JSON.parse(localStorage.getItem('passwordInfo') || '{}');
      const sessionInfo = JSON.parse(sessionStorage.getItem('passwordInfo') || '{}');
      if (localInfo.user === sessionInfo.user && localInfo.password === sessionInfo.password) {
        return;
      }
      logout();
    });

    const init = () => {
      const doctorInfoObj = getDoctorInfoStorage();
      username.value = doctorInfoObj.doctor_name;
      isCenterAdmin.value = JSON.parse(localStorage.getItem('CenterAdmin') || '{}');
      if (isCenterAdmin.value) {
        options.value = [
          {
            value: '项目进度查询',
            type: 'platformData',
          },
          {
            value: '项目数据统计',
            type: 'platformData',
          },
        ];
      }
    };

    init();

    return {
      username,
      patientName,
      modelSelect,
      showFollowUpTab,
      showPatientRecruitTab,
      recruitmentSelect,
      projectName,
      options,
      fullPath,
      refPlatformData,
      logout,
      clearAllSelect,
      manageChange,
      mouseenter,
      mouseleave,
    };
  },
};
